import {capturePostHogEvent, PostHogEvents} from "@/posthog";
import {locationAtom} from "@/store/jotaiAtoms";
import {useLocation} from "@tanstack/react-router";
import {useAtom} from "jotai";
import {useEffect} from "react";

const useLocationEffect = () => {
  const location = useLocation();
  const [value, setValue] = useAtom(locationAtom);

  useEffect(() => {
    if (value.currentRoute) {
      capturePostHogEvent(PostHogEvents.PageViewed, {path: location.pathname, previousPath: value.currentRoute});
    }

    setValue({
      previousRoute: value.currentRoute,
      currentRoute: `${location.pathname}${location.searchStr}`,
    });
  }, [location.pathname, setValue]);
};

export default useLocationEffect;
